import { Link } from "react-router-dom";
import { HeartHandshake, ShieldCheck, FileText } from "lucide-react";
import { LogoMark, Wordmark } from "./Logo";
import { useSite } from "../context/SiteContext";

export default function Footer() {
  const { site } = useSite();
  return (
    <footer className="border-t border-white/10 bg-[#07070c]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <LogoMark size={30} />
            <Wordmark className="text-lg" />
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            The ultimate music bot for Discord. High-fidelity audio, smart queues and 24/7 playback — free for every server.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/60 font-semibold mb-4">Product</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/features" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-features">Features</Link></li>
            <li><Link to="/commands" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-commands">Commands</Link></li>
            <li><Link to="/premium" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-premium">Premium</Link></li>
            <li><Link to="/boosters" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-boosters">Booster Perks</Link></li>
            <li><Link to="/changelog" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-changelog">Changelog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/60 font-semibold mb-4">Resources</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/docs" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-docs">Documentation</Link></li>
            <li><Link to="/status" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-status">Status</Link></li>
            <li><Link to="/support" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-support">Support</Link></li>
            <li><Link to="/dashboard" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-dashboard">Server Dashboard</Link></li>
            <li><Link to="/account" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-account">My Subscription</Link></li>
            <li><a href={site?.support_invite_url || "#"} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-white transition-colors duration-200" data-testid="footer-discord">Discord Server</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/60 font-semibold mb-4">Trust</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2 text-muted-foreground"><ShieldCheck size={14} className="text-emerald-400" /> No admin perms required</li>
            <li className="flex items-center gap-2 text-muted-foreground"><HeartHandshake size={14} className="text-blurple" /> Free forever core</li>
            <li className="flex items-center gap-2 text-muted-foreground"><FileText size={14} className="text-volt" /> Actively maintained</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40 font-mono">
        © {new Date().getFullYear()} GrooveMusic. Not affiliated with Discord Inc.
      </div>
    </footer>
  );
}
